/* eslint-disable */
/* tslint:disable */
import createApp from '/home/runner/work/jw-app/jw-app/src/main.ssr';
export { createApp };

if (process.client) {

}
import { UVue } from '@uvue/core';
import uvueConfig from '/home/runner/work/jw-app/jw-app/uvue.config';

const { plugins } = uvueConfig;
for (const index in plugins) {
  if (typeof plugins[index] === 'string') {
    plugins[index] = [plugins[index], {}];
  }
}
      
const plugin0 = require('../../uvue-plugins/vuex.js');
UVue.use(plugin0.default || plugin0, plugins[0][1]);
        
const plugin1 = require('../../uvue-plugins/apollo.js');
UVue.use(plugin1.default || plugin1, plugins[1][1]);
        